export default __webpack_public_path__ + "static/media/webcam2.2b44ae51.jfif";